import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import CartBuilder from "."

const StoryblokCartBuilder = ({ blok }: Storyblok.BlokProps<any>) => {
  return <CartBuilder {...storyblokEditable(blok)} />
}

export default StoryblokCartBuilder
